<template>
  <v-layout id="top-bar" align-center class="pa-0">
    <v-flex shrink>
      <paradigm-logo style="height: 36px"/>
    </v-flex>
    <v-spacer />
    <v-flex shrink>
      <the-user-dropdown />
    </v-flex>
  </v-layout>
</template>

<script>
import TheUserDropdown from '@/components/layout/TheUserDropdown'
import ParadigmLogo from '@/assets/svg/ParadigmLogo'

export default {
  components: {
    TheUserDropdown,
    ParadigmLogo
  }
}
</script>

<style lang="scss" scoped>
.viper-logo {
  height: 35px;
}
</style>
